const getters = {
  language: state => state.app.language, // 语言
  sidebar: state => state.app.sidebar, // 侧边栏
  userInfo: state => state.login.userInfo
}
export default getters
